import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import vuetify from './plugins/vuetify';
import VueImgOrientationChanger from 'vue-img-orientation-changer'
import axios from 'axios'

const token = localStorage.getItem('token')
if (token) {
  axios.defaults.headers.common['Authorization'] = `Bearer ${token}`
}
axios.interceptors.response.use(function (response) {
  return response
}, function (error) {
  console.log(error.response.status)
  if (error.response.status === 401) {
    store.dispatch('logout')
    router.push('/login')
  }
  return Promise.reject(error)
})

const VueCookie = require('vue-cookie');
Vue.use(VueCookie);

Vue.use(VueImgOrientationChanger)

Vue.config.productionTip = false

import '@/assets/style.css'

new Vue({
  router,
  store,
  vuetify,
  render: h => h(App)
}).$mount('#app')

